module.exports = __webpack_public_path__ + "img/logo-dne.60bdfe3e.svg";